import React from 'react';

interface FormattedDateProps {
    date: string;
    className?: string;
}

const FormattedDate: React.FC<FormattedDateProps> = ({ date, className }) => {
    const d = new Date(date);
    const formatted = `${d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}, ${d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' })}`;

    return <span className={className}>{formatted}</span>;
};

export default FormattedDate;
